import moment from "moment-timezone";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { store } from "./app/store";

// Every bare moment() call in this app should resolve/format in IST, not the
// viewer's own device timezone - this is a domestic India-only business.
moment.tz.setDefault("Asia/Kolkata");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <Provider store={store}> */}
      <App />
    {/* </Provider> */}
  </React.StrictMode>
);
